<template>
  <main>
    <MainArchive />
  </main>
</template>

<script>
const MainArchive = () => import('@/components/Archive/Main')

export default {
  components: {
    MainArchive
  },

  created () {
    // window.window.open('https://admanawards.com/oldsite/archive-2018/')

    // this.$rout.go(-1)
  },

  metaInfo: {
    meta: [
      { name: 'publisher', content: 'admanawards.com/' },
      { name: 'og:url', content: 'https://admanawards.com' },
      { name: 'og:title', content: 'Adman Awards & Symposium 2019' },
      { name: 'og:description', content: 'งานประกวด แสดงผลงาน และแลกเปลี่ยนเรียนรู้ ของคนในวงการโฆษณาและการสื่อสารการตลาด' },
      { name: 'og:image', content: 'https://admanawards.com/img/og_adman.jpg' },
      { name: 'og:site_name', content: 'AdmanAwards' },
      { name: 'og:type', content: 'website' }
    ]
  }
}
</script>
